import { Observable } from 'rxjs';
import { HvlResponse } from '@hvlng/framework-bff/core';
import { map } from 'rxjs/operators';
import { JsonConvert } from 'json2typescript';
import { HttpClient } from '@angular/common/http';
import { DateConflictControlModel } from './date-conflict-control-model';

export class MasterDataService {
    constructor(
        private httpClientInternal: HttpClient,
        private serviceRootPath: string,
        private endPoint: string,
    ) {}

    public checkExistsDateConflict(model: DateConflictControlModel): Observable<Boolean> {
        const pattern = this.serviceRootPath + 'checkExistsDateConflict';
        const converter = new JsonConvert();

        return this.httpClientInternal
            .post<HvlResponse<Boolean>>(this.endPoint + pattern, converter.serialize(model))
            .pipe(
                map((data) => {
                    return data.body;
                }),
            );
    }
}
